var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dfr-aggregate"}},[_c('b-tabs',{attrs:{"vertical":"","type":"is-boxed"}},[_c('b-tab-item',{attrs:{"label":"Employee"}},[_c('dfr-employee-aggregate')],1),_c('b-tab-item',{attrs:{"label":"Company"}},[_c('dfr-company-aggregate')],1),_c('b-tab-item',{attrs:{"label":"Historical"}},[_c('dfr-historical-reports')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }